import {axiosInstance} from '@/services/axiosInstance'

export const MerchantFilesResource = {
  getList: (parametros) => {
    return axiosInstance.get(
      'v1/merchantfiles',
      {
        params: parametros
      }
    )
  },
  
  registerMerchantFile: (parametros) =>
  {
      return axiosInstance.post( 'v1/merchantfiles',
      parametros
      )
  },

    
  deleteMerchantFile: (parametros) =>
  {
      return axiosInstance.post( 'v1/merchantfiles/delete',
      parametros
      )
  },


 

  // quando colamos parametros direto como segundo parametro da chamada axios, viram query string em um get
  getFileTypeKeyValue: (parametros) => {
    return axiosInstance.get(
      'v1/merchantfiles/filetype/keyvalue', 
      parametros
    )
  }
}